import useAppSelector from 'hooks/useAppSelector';
import { getPropertyUidFromStringType } from 'utils/property/propertyUtils';
import useStackedCalendarVisibleProperties from '../useStackedCalendarVisibleProperties';
import { stackedCalendarStyleConstants } from '../Calendar.constants';
import {
  MAX_RENDERED_ROWS,
  useRowVirtualizationRange,
} from '../useRowVirtualization';
import {
  PropertiesListContainer,
  PropertiesListElements,
} from './PropertiesList.styles';
import PropertiesListLoader from './PropertiesListLoader';
import PropertyListItem from './PropertyListItem';

const PropertiesList = () => {
  const isLoadingProperties = useAppSelector(
    (state) => state.stackedCalendar.isLoadingProperties,
  );
  const visibleProperties = useStackedCalendarVisibleProperties();

  const { startIndex, endIndex } = useRowVirtualizationRange();
  // Until the orchestrator (in the body) publishes a range, render a bounded window.
  const rowsInitialized = endIndex > 0;
  const effectiveStart = rowsInitialized ? startIndex : 0;
  const effectiveEnd = rowsInitialized
    ? endIndex
    : Math.min(visibleProperties.length, MAX_RENDERED_ROWS);
  const renderedProperties = visibleProperties.slice(
    effectiveStart,
    effectiveEnd,
  );
  const rowHeight = stackedCalendarStyleConstants.days.height;
  const topSpacerHeight = effectiveStart * rowHeight;
  const bottomSpacerHeight =
    Math.max(0, visibleProperties.length - effectiveEnd) * rowHeight;

  if (isLoadingProperties) {
    return <PropertiesListLoader />;
  }

  return (
    <PropertiesListContainer>
      <PropertiesListElements>
        {topSpacerHeight > 0 && (
          <div
            aria-hidden
            className="virtualization-loading-panel"
            style={{ flex: `0 0 ${topSpacerHeight}px` }}
          />
        )}
        {renderedProperties.map((uid) => {
          const { propertyUid } = getPropertyUidFromStringType(uid);
          return (
            <PropertyListItem key={propertyUid} propertyUid={propertyUid} />
          );
        })}
        {bottomSpacerHeight > 0 && (
          <div
            aria-hidden
            className="virtualization-loading-panel"
            style={{ flex: `0 0 ${bottomSpacerHeight}px` }}
          />
        )}
      </PropertiesListElements>
    </PropertiesListContainer>
  );
};

export default PropertiesList;
